/** First-party confirmation UI; source behavior is retained without its jQuery bundle. */
class BotanicAgeConfirmation extends HTMLElement {
  static #acceptedThisDocument = false;
  #controller;
  #timer;
  #dialog;
  #addedScrollClass = false;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#dialog = this.querySelector('dialog');
    if (!this.#dialog) return;

    this.querySelector('[data-age-yes]')?.addEventListener('click', () => {
      BotanicAgeConfirmation.#acceptedThisDocument = true;
      try {
        localStorage.setItem('freshAgeVerification', 'shown');
      } catch {
        // Storage may be disabled; confirmation still closes for this document.
      }
      this.#close('yes');
    }, { signal });

    this.querySelector('[data-age-no]')?.addEventListener('click', () => {
      this.#close('no');
      window.location.assign('https://www.google.com/');
    }, { signal });

    this.#dialog.addEventListener('close', this.#restoreScrolling, { signal });
    this.#dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.#close('');
    }, { signal });
    this.#dialog.addEventListener('keydown', this.#trapFocus, { signal });
    if (this.#alreadyConfirmed()) return;
    this.#timer = window.setTimeout(() => {
      if (!this.isConnected || this.#alreadyConfirmed()) return;
      this.#addedScrollClass = !document.body.classList.contains('botanic-age-confirmation-open');
      document.body.classList.add('botanic-age-confirmation-open');
      this.#dialog.showModal();
      this.querySelector('[data-age-yes]')?.focus();
    }, 2000);
  }

  disconnectedCallback() {
    window.clearTimeout(this.#timer);
    this.#controller?.abort();
    if (this.#dialog?.open) this.#dialog.close();
    this.#restoreScrolling();
  }

  #alreadyConfirmed() {
    if (BotanicAgeConfirmation.#acceptedThisDocument) return true;
    try {
      return localStorage.getItem('freshAgeVerification') === 'shown';
    } catch {
      return false;
    }
  }

  #close(value) {
    this.#dialog.close(value);
    this.#restoreScrolling();
  }

  #restoreScrolling = () => {
    if (this.#addedScrollClass) document.body.classList.remove('botanic-age-confirmation-open');
    this.#addedScrollClass = false;
  };

  #trapFocus = (event) => {
    if (event.key !== 'Tab') return;
    const buttons = Array.from(this.#dialog.querySelectorAll('button:not([disabled])'))
      .filter(button => button.getClientRects().length > 0);
    const first = buttons[0];
    const last = buttons.at(-1);
    if (!first || !last) return;
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };
}

if (!customElements.get('botanic-age-confirmation')) {
  customElements.define('botanic-age-confirmation', BotanicAgeConfirmation);
}
